export default __webpack_public_path__ + "static/media/Bubshur.301778e4.jpg";